import { render, staticRenderFns } from "./Representative.vue?vue&type=template&id=7668e0d4&scoped=true&"
import script from "./Representative.vue?vue&type=script&lang=js&"
export * from "./Representative.vue?vue&type=script&lang=js&"
import style0 from "./Representative.vue?vue&type=style&index=0&id=7668e0d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7668e0d4",
  null
  
)

export default component.exports